<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <form @submit.prevent="onSubmit">
        <v-card-title>
          <span class="headline">{{
            mess.dialog_select_on_company_title
          }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <div
                  id="map-company"
                  style="width: 100%; height: 300px; background: #c9c9c9"
                ></div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions style="padding: 0 24px 16px">
          <v-spacer></v-spacer>
          <v-btn color="primary" depressed dark @click="dialog = false">{{
            mess.dialog_base_button_close
          }}</v-btn>
          <v-btn color="primary" depressed dark type="submit">{{
            mess.dialog_base_button_save
          }}</v-btn>
        </v-card-actions>
        <v-btn absolute top right text icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CompanyOnMapDialog",
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dialog: false,
    companyMap: null,
    coords: null,
    address: null
  }),
  methods: {
    onSubmit() {
      if (this.coords && this.address)
        this.$emit("set-address", {
          coords: this.coords,
          address: this.address
        });
      this.dialog = false;
    },
    initMap() {
      var self = this;
      // eslint-disable-next-line no-undef
      ymaps.ready(init);

      function init() {
        var myPlacemark;
        // eslint-disable-next-line no-undef
        self.companyMap = new ymaps.Map("map-company", {
          center: [55.76, 37.64],
          zoom: 7
        });

        var myMap = self.companyMap;

        // Слушаем клик на карте.
        myMap.events.add("click", function(e) {
          var coords = e.get("coords");
          // записываем координаты в form.coords
          self.coords = coords;

          // Если метка уже создана – просто передвигаем ее.
          if (myPlacemark) {
            myPlacemark.geometry.setCoordinates(coords);
          }
          // Если нет – создаем.
          else {
            myPlacemark = createPlacemark(coords);
            myMap.geoObjects.add(myPlacemark);
            // Слушаем событие окончания перетаскивания на метке.
            myPlacemark.events.add("dragend", function() {
              getAddress(myPlacemark.geometry.getCoordinates());
            });
          }
          getAddress(coords);
        });

        // Создание метки.
        function createPlacemark(coords) {
          // eslint-disable-next-line no-undef
          return new ymaps.Placemark(
            coords,
            {
              iconCaption: "поиск..."
            },
            {
              preset: "islands#violetDotIconWithCaption",
              draggable: true
            }
          );
        }

        // Определяем адрес по координатам (обратное геокодирование).
        function getAddress(coords) {
          myPlacemark.properties.set("iconCaption", "поиск...");
          // eslint-disable-next-line no-undef
          ymaps.geocode(coords).then(function(res) {
            var firstGeoObject = res.geoObjects.get(0);

            self.address = firstGeoObject.getLocalities().length
              ? firstGeoObject.getAddressLine()
              : firstGeoObject.getAdministrativeAreas();

            myPlacemark.properties.set({
              // Формируем строку с данными об объекте.
              iconCaption: [
                // Название населенного пункта или вышестоящее административно-территориальное образование.
                firstGeoObject.getLocalities().length
                  ? firstGeoObject.getLocalities()
                  : firstGeoObject.getAdministrativeAreas(),
                // Получаем путь до топонима, если метод вернул null, запрашиваем наименование здания.
                firstGeoObject.getThoroughfare() || firstGeoObject.getPremise()
              ]
                .filter(Boolean)
                .join(", "),
              // В качестве контента балуна задаем строку с адресом объекта.
              balloonContent: firstGeoObject.getAddressLine()
            });
          });
        }
      }
    },
    isVisibleDomNode(element) {
      const computedStyle = window.getComputedStyle(element);
      return computedStyle.display !== "none";
    },
    updateMap() {
      const intervalId = setInterval(() => {
        // eslint-disable-next-line no-console
        console.log(this.mapContainer);
        if (this.isVisibleDomNode(this.mapContainer)) {
          this.map.container.fitToViewport(true);
          clearInterval(intervalId);
        }
      }, 100);
    }
  },
  computed: {
    mapContainer() {
      return this.$refs["map-wrapper"].$el;
    }
  },
  watch: {
    isVisible(val) {
      this.dialog = val;

      if (val) {
        !this.companyMap ? this.initMap() : null;
      }
    },
    dialog(val) {
      this.$emit("update:is-visible", val);
    }
  },
  mounted() {}
};
</script>

<style lang="scss"></style>
